import { render, staticRenderFns } from "./index.vue?vue&type=template&id=280ab530"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280ab530')) {
      api.createRecord('280ab530', component.options)
    } else {
      api.reload('280ab530', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=280ab530", function () {
      api.rerender('280ab530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/paquetes/index.vue"
export default component.exports